import { createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin((nuxt) => {
  const {
    public: { gtm },
  } = useRuntimeConfig()

  nuxt.vueApp.use(createGtm(gtm))
})
